import { render } from "./DetailView.vue?vue&type=template&id=759a821b&scoped=true"
import script from "./DetailView.vue?vue&type=script&lang=js"
export * from "./DetailView.vue?vue&type=script&lang=js"

import "./DetailView.vue?vue&type=style&index=0&id=759a821b&scoped=true&lang=css"

import exportComponent from "D:\\도연희\\vuestudy\\vue-ghibli\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-759a821b"]])

export default __exports__